{
  "api_clients.actions.create": "新建客户端",
  "api_clients.actions.permissions": "分配权限",
  "api_clients.actions.apps": "授权应用",
  "api_clients.actions.rotate": "创建密钥",
  "api_clients.actions.secrets": "管理密钥",
  "api_clients.cidrs.any": "任意来源",
  "api_clients.columns.actions": "操作",
  "api_clients.columns.apps": "授权应用数",
  "api_clients.columns.cidrs": "允许的 CIDR 数",
  "api_clients.columns.name": "客户端",
  "api_clients.columns.secrets": "有效密钥",
  "api_clients.columns.status": "状态",
  "api_clients.description": "管理租户内的机器身份、网络范围、凭据和稳定权限代码。",
  "api_clients.detail.back": "返回 API 客户端",
  "api_clients.detail.client_id": "客户端 ID",
  "api_clients.detail.created_at": "创建时间",
  "api_clients.detail.description": "查看当前租户的机器身份信息，不暴露任何明文凭据。",
  "api_clients.detail.expires_at": "过期时间",
  "api_clients.detail.load_error": "API 客户端详情加载失败。",
  "api_clients.detail.no_permissions": "未分配权限码",
  "api_clients.detail.no_secrets": "没有密钥元数据",
  "api_clients.detail.permissions": "权限码",
  "api_clients.detail.updated_at": "更新时间",
  "api_clients.editor.cidrs": "允许的 CIDR",
  "api_clients.editor.cidrs_help": "每行或逗号分隔；留空表示不按来源 IP 限制。",
  "api_clients.editor.create": "新建 API 客户端",
  "api_clients.editor.description": "说明",
  "api_clients.editor.edit": "编辑 API 客户端",
  "api_clients.editor.expires": "到期时间",
  "api_clients.editor.name": "名称",
  "api_clients.editor.status": "状态",
  "api_clients.empty": "暂无匹配的 API 客户端",
  "api_clients.feedback.error": "操作失败，请检查输入和权限后重试",
  "api_clients.feedback.revoked": "客户端密钥已吊销",
  "api_clients.feedback.saved": "API 客户端已保存",
  "api_clients.feedback.apps_saved": "应用访问范围已保存",
  "api_clients.apps.title": "授权可访问的应用",
  "api_clients.apps.selector": "应用访问白名单",
  "api_clients.apps.empty_denies": "空白名单会拒绝该客户端访问任何应用；必须显式选择允许访问的 App。",
  "api_clients.filters.landmark": "API 客户端筛选",
  "api_clients.filters.query": "搜索名称或客户端 ID",
  "api_clients.filters.status": "客户端状态",
  "api_clients.permissions.selector": "客户端权限代码",
  "api_clients.permissions.title": "分配稳定权限代码",
  "api_clients.safety.description": "客户端密钥只显示一次且服务端仅保存 Hash；签发令牌固定为 ak-api audience，不能调用 Admin API。",
  "api_clients.safety.title": "机器令牌与管理令牌隔离",
  "api_clients.secret.ack": "我已安全保存此密钥",
  "api_clients.secret.close": "已保存并关闭",
  "api_clients.secret.title": "保存客户端密钥",
  "api_clients.secret.value": "客户端密钥",
  "api_clients.secret.warning": "此密钥只显示一次。关闭后无法恢复，请立即复制到安全存储。",
  "api_clients.secrets.active": "有效",
  "api_clients.secrets.limit": "最多同时保留两个有效密钥，便于无中断轮换。",
  "api_clients.secrets.revoke": "吊销",
  "api_clients.secrets.revoke_confirm": "吊销 {prefix} 后，使用该密钥的新请求会立即失败。",
  "api_clients.secrets.revoke_title": "吊销客户端密钥",
  "api_clients.secrets.revoked": "已吊销",
  "api_clients.secrets.title": "客户端密钥",
  "api_clients.status.active": "启用",
  "api_clients.status.disabled": "停用",
  "api_clients.title": "API 客户端",
  "block_rules.action.challenge": "要求挑战",
  "block_rules.action.deny": "阻断",
  "block_rules.action.rate_limit": "限流",
  "block_rules.actions.create": "新建规则",
  "block_rules.actions.revoke": "撤销",
  "block_rules.columns.actions": "操作",
  "block_rules.columns.expiry": "到期时间",
  "block_rules.columns.scope": "范围",
  "block_rules.columns.status": "状态",
  "block_rules.columns.subject": "脱敏对象",
  "block_rules.description": "管理当前租户的阻断、挑战和限流规则；对象始终由服务端脱敏。",
  "block_rules.editor.action": "动作",
  "block_rules.editor.create": "新建访问控制规则",
  "block_rules.editor.edit": "编辑访问控制规则",
  "block_rules.editor.expires_at": "到期时间",
  "block_rules.editor.reason": "原因",
  "block_rules.editor.starts_at": "开始时间",
  "block_rules.editor.status": "状态",
  "block_rules.editor.subject_help": "原始值仅用于创建，保存后只返回脱敏提示。",
  "block_rules.editor.subject_redacted": "已保存对象不可回显或修改；如需更换，请撤销并新建规则。",
  "block_rules.editor.subject_type": "对象类型",
  "block_rules.editor.subject_value": "对象值",
  "block_rules.empty": "暂无访问控制规则",
  "block_rules.expiry.active": "有效",
  "block_rules.expiry.expired": "已过期",
  "block_rules.expiry.never": "永不过期",
  "block_rules.feedback.error": "访问控制操作失败，请检查输入和权限",
  "block_rules.feedback.revoked": "访问控制规则已撤销",
  "block_rules.feedback.saved": "访问控制规则已保存",
  "block_rules.feedback.validation": "请检查对象格式、时间范围并确认影响",
  "block_rules.filters.expiry": "有效期",
  "block_rules.filters.hint": "搜索脱敏对象",
  "block_rules.filters.landmark": "访问控制筛选",
  "block_rules.filters.status": "状态",
  "block_rules.filters.type": "对象类型",
  "block_rules.impact.ack": "我已核对对象、范围、动作和有效期",
  "block_rules.impact.description": "将对 {subject} 应用“{action}”。请确认范围和有效期。",
  "block_rules.impact.pending": "待填写对象",
  "block_rules.impact.title": "影响确认",
  "block_rules.revoke.confirm": "将撤销 {subject} 的“{action}”规则，并保留不可变审计记录。",
  "block_rules.revoke.title": "撤销访问控制规则？",
  "block_rules.safety.description": "创建或撤销前请核对对象、范围、动作和有效期。列表、审计和截图不会显示原始对象。",
  "block_rules.safety.title": "规则会影响登录与访问决策",
  "block_rules.scope.tenant": "当前租户",
  "block_rules.status.active": "启用",
  "block_rules.status.disabled": "停用",
  "block_rules.subject.cidr": "IP 网段",
  "block_rules.subject.device": "设备",
  "block_rules.subject.identifier": "登录标识",
  "block_rules.subject.ip": "IP 地址",
  "block_rules.subject.user": "用户",
  "block_rules.title": "访问控制",
  "ops.actions.copy": "复制诊断摘要",
  "ops.capabilities.access_rules": "访问规则",
  "ops.capabilities.api_clients": "API 客户端",
  "ops.capabilities.assignments": "任职关系",
  "ops.capabilities.authentication": "身份认证",
  "ops.capabilities.avatars": "头像",
  "ops.capabilities.configuration": "系统配置",
  "ops.capabilities.deliveries": "投递记录",
  "ops.capabilities.dependency_status": "依赖状态",
  "ops.capabilities.dictionaries": "数据字典",
  "ops.capabilities.files": "文件",
  "ops.capabilities.health": "服务健康",
  "ops.capabilities.login_logs": "登录日志",
  "ops.capabilities.menus": "菜单",
  "ops.capabilities.messages": "消息",
  "ops.capabilities.mfa": "多因素认证",
  "ops.capabilities.multipart_upload": "分片上传",
  "ops.capabilities.notices": "公告",
  "ops.capabilities.oauth": "OAuth",
  "ops.capabilities.operation_logs": "操作日志",
  "ops.capabilities.positions": "岗位",
  "ops.capabilities.private_download": "受保护下载",
  "ops.capabilities.queue_summary": "队列摘要",
  "ops.capabilities.regions": "地区",
  "ops.capabilities.roles": "角色",
  "ops.capabilities.runs": "执行记录",
  "ops.capabilities.runtime_summary": "运行摘要",
  "ops.capabilities.schedules": "调度计划",
  "ops.capabilities.security_events": "安全事件",
  "ops.capabilities.sessions": "会话",
  "ops.capabilities.templates": "模板",
  "ops.capabilities.tenants": "租户",
  "ops.capabilities.units": "组织单元",
  "ops.capabilities.users": "用户",
  "ops.capabilities.webhooks": "Webhook",
  "ops.capabilities.worker": "Worker",
  "ops.columns.capabilities": "能力",
  "ops.columns.checked": "检查时间",
  "ops.columns.dependency": "依赖",
  "ops.columns.latency": "延迟",
  "ops.columns.module": "模块",
  "ops.columns.status": "状态",
  "ops.columns.version": "版本",
  "ops.dependencies.table_label": "依赖健康详情",
  "ops.dependencies.title": "依赖健康",
  "ops.dependency.api": "API",
  "ops.dependency.object_storage": "对象存储",
  "ops.dependency.postgresql": "PostgreSQL",
  "ops.dependency.redis": "Redis",
  "ops.description": "查看 API、依赖、Worker、队列和运行版本的安全诊断摘要。",
  "ops.latency": "{value} 毫秒",
  "ops.loading": "加载中",
  "ops.module_status.disabled": "停用",
  "ops.module_status.enabled": "启用",
  "ops.modules.audit.description": "操作日志、登录日志和安全事件。",
  "ops.modules.audit.name": "审计与安全",
  "ops.modules.empty": "暂无编译内置模块",
  "ops.modules.iam.description": "认证、用户、租户、角色、会话、多因素认证、OAuth 与访问规则。",
  "ops.modules.iam.name": "身份与权限",
  "ops.modules.jobs.description": "调度计划、执行记录和 Worker 处理。",
  "ops.modules.jobs.name": "任务调度",
  "ops.modules.notify.description": "公告、消息、模板和投递跟踪。",
  "ops.modules.notify.name": "通知",
  "ops.modules.ops.description": "服务健康、运行摘要、依赖和队列状态。",
  "ops.modules.ops.name": "运行监控",
  "ops.modules.org.description": "组织单元、岗位和用户任职关系。",
  "ops.modules.org.name": "组织架构",
  "ops.modules.storage.description": "头像、文件、分片上传和受保护下载。",
  "ops.modules.storage.name": "存储",
  "ops.modules.sys.description": "配置、字典、地区、菜单、API 客户端和 Webhook。",
  "ops.modules.sys.name": "系统配置",
  "ops.modules.table_label": "编译内置领域模块详情",
  "ops.modules.title": "编译内置领域模块",
  "ops.runtime.app_version": "应用版本",
  "ops.runtime.failed_runs": "24 小时失败任务",
  "ops.runtime.go_version": "Go 版本",
  "ops.runtime.heartbeat": "最近 Worker 心跳",
  "ops.runtime.success_runs": "24 小时成功任务",
  "ops.runtime.title": "运行摘要",
  "ops.runtime.uptime": "运行时长",
  "ops.safety.description": "页面不显示连接串、密钥、环境变量、本地路径或原始异常。未配置和未知不会显示为通过。",
  "ops.safety.title": "诊断信息已受控",
  "ops.status.degraded": "降级",
  "ops.status.not_configured": "未配置",
  "ops.status.ready": "正常",
  "ops.status.unavailable": "不可用",
  "ops.status.unknown": "未知",
  "ops.summary.overall": "整体状态",
  "ops.summary.pending": "待处理队列",
  "ops.summary.worker": "Worker 状态",
  "ops.title": "服务状态",
  "ops.uptime": "{value} 秒",
  "schedules.actions.create": "新建任务",
  "schedules.actions.execute": "立即执行",
  "schedules.actions.pause": "暂停",
  "schedules.actions.resume": "恢复",
  "schedules.actions.runs": "运行记录",
  "schedules.columns.actions": "操作",
  "schedules.columns.cron": "Cron 与时区",
  "schedules.columns.handler": "处理器",
  "schedules.columns.name": "任务名称",
  "schedules.columns.next_run": "下次运行",
  "schedules.columns.status": "状态",
  "schedules.cron.custom": "Cron：{expression}",
  "schedules.cron.daily": "每天零点执行",
  "schedules.cron.every_minute": "每分钟执行",
  "schedules.cron.hourly": "每小时整点执行",
  "schedules.description": "管理经过编译注册的后台任务、Cron 时区策略与安全执行历史。",
  "schedules.editor.code": "任务编码",
  "schedules.editor.create_title": "新建定时任务",
  "schedules.editor.cron": "Cron 表达式",
  "schedules.editor.edit_title": "编辑定时任务",
  "schedules.editor.handler": "已注册处理器",
  "schedules.editor.handler_help": "只可选择由服务端编译注册的安全处理器。",
  "schedules.editor.max_attempts": "最大尝试次数",
  "schedules.editor.misfire": "错过执行策略",
  "schedules.editor.name": "任务名称",
  "schedules.editor.overlap": "重叠策略",
  "schedules.editor.payload": "任务参数 JSON",
  "schedules.editor.payload_help": "仅允许当前处理器声明的对象字段；敏感凭据不得写入任务参数。",
  "schedules.editor.time_zone": "IANA 时区",
  "schedules.editor.time_zone_help": "示例：Asia/Shanghai、America/New_York。",
  "schedules.editor.timeout": "超时秒数",
  "schedules.empty": "暂无匹配的定时任务",
  "schedules.execute.confirm": "确认将“{name}”以已注册处理器 {handler} 加入队列？重复提交会由幂等键保护。",
  "schedules.execute.title": "立即执行此任务？",
  "schedules.feedback.action_error": "操作失败，任务状态可能已变化，请刷新后重试。",
  "schedules.feedback.executed": "任务已安全加入执行队列。",
  "schedules.feedback.load_error": "无法加载定时任务。",
  "schedules.feedback.paused": "定时任务已暂停。",
  "schedules.feedback.preview_error": "无法解析 Cron 表达式或时区。",
  "schedules.feedback.resumed": "定时任务已恢复。",
  "schedules.feedback.runs_error": "无法加载运行记录。",
  "schedules.feedback.save_error": "无法保存定时任务，请检查输入后重试。",
  "schedules.feedback.saved": "定时任务已保存。",
  "schedules.filters.landmark": "定时任务筛选",
  "schedules.filters.query": "搜索名称或编码",
  "schedules.filters.status": "任务状态",
  "schedules.filters.time_zone": "时区",
  "schedules.handlers.system_health_snapshot.description": "检查 PostgreSQL 可用性并记录稳定结果码。",
  "schedules.handlers.system_health_snapshot.name": "系统健康快照",
  "schedules.misfire.catch_up": "有限追赶",
  "schedules.misfire.fire_once": "补执行一次",
  "schedules.misfire.ignore": "忽略错过的运行",
  "schedules.overlap.allow": "允许并行",
  "schedules.overlap.replace": "取消旧运行并替换",
  "schedules.overlap.skip": "跳过重叠运行",
  "schedules.preview.action": "重新计算",
  "schedules.preview.empty": "输入有效的 Cron 与时区后查看服务端计算结果。",
  "schedules.preview.item": "第 {count} 次",
  "schedules.preview.title": "接下来 5 次运行",
  "schedules.run_status.cancelled": "已取消",
  "schedules.run_status.failed": "失败",
  "schedules.run_status.queued": "排队中",
  "schedules.run_status.running": "执行中",
  "schedules.run_status.skipped": "已跳过",
  "schedules.run_status.succeeded": "成功",
  "schedules.runs.back": "返回定时任务",
  "schedules.runs.columns.attempt": "尝试次数",
  "schedules.runs.columns.result": "安全结果",
  "schedules.runs.columns.scheduled": "计划时间",
  "schedules.runs.columns.status": "状态",
  "schedules.runs.columns.trigger": "触发方式",
  "schedules.runs.description": "查看定时任务 {id} 在当前租户内的运行记录；结果只包含服务端有界安全摘要。",
  "schedules.runs.empty": "暂无匹配的运行记录",
  "schedules.runs.filters.status": "运行状态",
  "schedules.runs.load_error": "执行记录加载失败。",
  "schedules.runs.page_title": "执行记录",
  "schedules.runs.schedule_id": "定时任务 ID",
  "schedules.runs.table_landmark": "任务运行记录列表",
  "schedules.runs.title": "“{name}”运行记录",
  "schedules.safety.description": "任务不能执行 Shell、SQL 或上传代码；时区使用 IANA 标识，并由服务端计算夏令时边界。",
  "schedules.safety.title": "仅允许已注册处理器",
  "schedules.status.active": "运行中",
  "schedules.status.disabled": "已停用",
  "schedules.status.paused": "已暂停",
  "schedules.status_change.pause_confirm": "暂停“{name}”后将不再产生新的计划运行，已入队的运行不受影响。",
  "schedules.status_change.pause_title": "暂停定时任务？",
  "schedules.status_change.resume_confirm": "恢复“{name}”后将按照 Cron 和时区继续调度。",
  "schedules.status_change.resume_title": "恢复定时任务？",
  "schedules.table.landmark": "定时任务列表",
  "schedules.title": "定时任务",
  "schedules.trigger.manual": "手动",
  "schedules.trigger.retry": "重试",
  "schedules.trigger.schedule": "计划",
  "schedules.validation.invalid": "请检查此字段。",
  "system.access.load_error": "访问控制数据加载失败",
  "system.access.menus.actions.create": "新建菜单",
  "system.access.menus.actions.label": "操作",
  "system.access.menus.actions.move": "移动",
  "system.access.menus.component_notice": "页面组件只能从编译期静态路由注册表选择；菜单不会授予 API 权限。",
  "system.access.menus.core": "核心菜单",
  "system.access.menus.delete.impact": "存在子菜单或角色分配时不能删除，当前角色分配数：{count}。",
  "system.access.menus.delete.title": "删除此菜单？",
  "system.access.menus.description": "管理当前租户菜单树；核心菜单可见但不可修改。",
  "system.access.menus.editor.create_title": "新建菜单",
  "system.access.menus.editor.edit_title": "编辑菜单",
  "system.access.menus.editor.title": "菜单编辑器",
  "system.access.menus.empty": "没有符合筛选条件的菜单",
  "system.access.menus.feedback.created": "菜单已创建",
  "system.access.menus.feedback.deleted": "菜单已删除",
  "system.access.menus.feedback.moved": "菜单已移动",
  "system.access.menus.feedback.saved": "菜单已保存",
  "system.access.menus.fields.affix": "固定",
  "system.access.menus.fields.code": "菜单编码",
  "system.access.menus.fields.component": "静态组件",
  "system.access.menus.fields.external_url": "外部链接",
  "system.access.menus.fields.hidden": "隐藏",
  "system.access.menus.fields.i18n_key": "翻译键",
  "system.access.menus.fields.icon": "图标键",
  "system.access.menus.fields.parent": "上级菜单",
  "system.access.menus.fields.path": "路由路径",
  "system.access.menus.fields.permission": "查看权限",
  "system.access.menus.fields.sort_order": "排序",
  "system.access.menus.fields.status": "状态",
  "system.access.menus.fields.title": "标题",
  "system.access.menus.fields.type": "菜单类型",
  "system.access.menus.filters.query": "搜索标题或编码",
  "system.access.menus.filters.status": "按状态筛选",
  "system.access.menus.filters.type": "按类型筛选",
  "system.access.menus.move.description": "选择上级菜单和排序；后端会拒绝循环以及超过三级的树。",
  "system.access.menus.move.title": "移动菜单",
  "system.access.menus.root": "根级",
  "system.access.menus.type.directory": "目录",
  "system.access.menus.type.external": "外部链接",
  "system.access.menus.type.page": "页面",
  "system.access.permissions.copied": "已复制 {code}",
  "system.access.permissions.copy": "复制权限码",
  "system.access.permissions.description": "由后端代码与种子定义的稳定权限码只读目录。",
  "system.access.permissions.empty": "没有符合筛选条件的权限",
  "system.access.permissions.fields.action": "动作",
  "system.access.permissions.fields.code": "权限码",
  "system.access.permissions.fields.kind": "类型",
  "system.access.permissions.fields.name": "名称",
  "system.access.permissions.fields.resource": "模块 / 资源",
  "system.access.permissions.fields.status": "状态",
  "system.access.permissions.filters.kind": "按类型筛选",
  "system.access.permissions.filters.module": "按模块筛选",
  "system.access.permissions.filters.query": "搜索权限码或名称",
  "system.access.permissions.filters.status": "按状态筛选",
  "system.access.permissions.kind.api": "API",
  "system.access.permissions.kind.feature": "功能",
  "system.access.permissions.kind.ui_action": "界面动作",
  "system.access.permissions.read_only": "只读",
  "system.access.roles.actions.create": "新建角色",
  "system.access.roles.actions.label": "操作",
  "system.access.roles.delete.impact": "仅无成员角色可删除，当前成员数：{count}。",
  "system.access.roles.delete.title": "删除此角色？",
  "system.access.roles.description": "管理租户角色，并严格分离 API 权限、导航菜单和数据范围。",
  "system.access.roles.detail.back": "返回角色列表",
  "system.access.roles.detail.basic": "基本信息",
  "system.access.roles.detail.data_scope": "数据范围",
  "system.access.roles.detail.members": "成员",
  "system.access.roles.detail.menus": "菜单",
  "system.access.roles.detail.permissions": "权限",
  "system.access.roles.editor.create_title": "新建自定义角色",
  "system.access.roles.empty": "没有符合筛选条件的角色",
  "system.access.roles.feedback.created": "角色 {name} 已创建",
  "system.access.roles.feedback.deleted": "角色 {name} 已删除",
  "system.access.roles.feedback.menus_saved": "角色菜单已保存",
  "system.access.roles.feedback.permissions_saved": "角色权限已保存",
  "system.access.roles.feedback.saved": "角色设置已保存",
  "system.access.roles.feedback.scope_saved": "角色数据范围已保存",
  "system.access.roles.fields.code": "角色编码",
  "system.access.roles.fields.description": "描述",
  "system.access.roles.fields.members": "成员数",
  "system.access.roles.fields.name": "角色名称",
  "system.access.roles.fields.scope": "数据范围",
  "system.access.roles.fields.scope_units": "自定义组织单元",
  "system.access.roles.fields.sort_order": "排序",
  "system.access.roles.fields.status": "状态",
  "system.access.roles.fields.type": "角色类型",
  "system.access.roles.filters.query": "搜索角色名称或编码",
  "system.access.roles.filters.status": "按状态筛选",
  "system.access.roles.filters.type": "按角色类型筛选",
  "system.access.roles.members.description": "打开带此角色筛选的用户列表来管理角色成员。",
  "system.access.roles.members.open": "打开筛选后的用户",
  "system.access.roles.menu_separation": "菜单只控制导航展示；API 授权始终由独立的权限选择决定。",
  "system.access.roles.scope.all": "全部数据",
  "system.access.roles.scope.custom": "自定义组织单元",
  "system.access.roles.scope.department": "本部门",
  "system.access.roles.scope.department_tree": "本部门及下级",
  "system.access.roles.scope.self": "仅本人",
  "system.access.roles.scope.tenant": "当前租户",
  "system.access.roles.system_immutable": "此系统角色由平台种子维护，不能在此修改或删除。",
  "system.access.roles.type.custom": "自定义角色",
  "system.access.roles.type.system": "系统角色",
  "system.access.selected": "已选择 {count} 项",
  "system.access.status.active": "正常",
  "system.access.status.disabled": "已停用",
  "system.audit.actions.copy_request_id": "复制请求 ID",
  "system.audit.actions.resolve": "处理事件",
  "system.audit.actions.view": "查看详情",
  "system.audit.event_detail.back": "返回安全事件",
  "system.audit.event_detail.details": "脱敏详情",
  "system.audit.event_detail.metadata": "事件元数据",
  "system.audit.event_detail.redaction_notice": "凭据、令牌、秘密、授权、Cookie、OTP、MFA 和 API Key 字段均由服务端脱敏。",
  "system.audit.events.description": "调查当前租户的安全事件，并记录不可变的处理操作。",
  "system.audit.events.empty": "没有符合筛选条件的安全事件。",
  "system.audit.feedback.request_id_copied": "请求 ID 已复制。",
  "system.audit.fields.action": "操作",
  "system.audit.fields.actions": "操作",
  "system.audit.fields.audience": "受众",
  "system.audit.fields.auth_method": "认证方式",
  "system.audit.fields.event_type": "事件类型",
  "system.audit.fields.failure_reason": "失败原因",
  "system.audit.fields.identifier_hint": "标识提示",
  "system.audit.fields.ip": "客户端 IP",
  "system.audit.fields.module": "模块",
  "system.audit.fields.request_id": "请求 ID",
  "system.audit.fields.resolved_by": "处理人",
  "system.audit.fields.resource": "资源",
  "system.audit.fields.result": "结果",
  "system.audit.fields.session_id": "会话 ID",
  "system.audit.fields.severity": "严重级别",
  "system.audit.fields.source": "来源",
  "system.audit.fields.status": "状态",
  "system.audit.fields.time": "时间",
  "system.audit.fields.user_id": "用户 ID",
  "system.audit.filters.audience": "受众",
  "system.audit.filters.auth_method": "认证方式",
  "system.audit.filters.from": "开始日期",
  "system.audit.filters.module": "模块",
  "system.audit.filters.query": "搜索请求、操作、事件或安全标识提示",
  "system.audit.filters.result": "结果",
  "system.audit.filters.severity": "严重级别",
  "system.audit.filters.source": "来源",
  "system.audit.filters.status": "状态",
  "system.audit.filters.to": "结束日期",
  "system.audit.load_error": "审计数据加载失败。",
  "system.audit.logins.description": "查看认证结果，不暴露完整账号标识或凭据材料。",
  "system.audit.logins.empty": "没有符合筛选条件的登录日志。",
  "system.audit.operation_detail.after": "变更后",
  "system.audit.operation_detail.before": "变更前",
  "system.audit.operation_detail.empty_json": "没有记录字段",
  "system.audit.operation_detail.redaction_notice": "敏感字段会在数据到达浏览器前由服务端递归脱敏。",
  "system.audit.operation_detail.request_summary": "请求摘要",
  "system.audit.operation_detail.title": "操作详情",
  "system.audit.operations.description": "查看当前租户的管理操作与经过字段级脱敏的变更。",
  "system.audit.operations.empty": "没有符合筛选条件的操作日志。",
  "system.audit.resolve.already": "此安全事件已经处理。",
  "system.audit.resolve.impact": "系统会把您的用户、会话、请求和处理时间写入不可变操作审计；同一事件不能重复处理。",
  "system.audit.resolve.success": "安全事件已处理并完成审计。",
  "system.audit.resolve.title": "处理此安全事件？",
  "system.audit.values.blocked": "已阻止",
  "system.audit.values.critical": "严重",
  "system.audit.values.failure": "失败",
  "system.audit.values.high": "高",
  "system.audit.values.info": "信息",
  "system.audit.values.low": "低",
  "system.audit.values.medium": "中",
  "system.audit.values.open": "待处理",
  "system.audit.values.resolved": "已处理",
  "system.audit.values.success": "成功",
  "system.audit.values.unknown": "暂无",
  "system.files.actions.cancel_upload": "取消上传",
  "system.files.actions.choose": "选择文件",
  "system.files.actions.details": "查看详情",
  "system.files.actions.download": "下载",
  "system.files.actions.pause": "暂停",
  "system.files.actions.resume": "继续上传",
  "system.files.actions.select": "选择",
  "system.files.actions.upload": "上传文件",
  "system.files.columns.actions": "操作",
  "system.files.columns.created": "创建时间",
  "system.files.columns.file": "文件",
  "system.files.columns.provider": "存储驱动",
  "system.files.columns.scan": "扫描",
  "system.files.columns.size": "大小",
  "system.files.columns.status": "状态",
  "system.files.columns.uploaded": "上传时间",
  "system.files.columns.usages": "引用",
  "system.files.delete.impact": "文件对象将被移除且无法恢复。",
  "system.files.delete.in_use": "该文件存在 {count} 个业务引用，不能删除。",
  "system.files.delete.title": "删除文件？",
  "system.files.description": "上传、查看并安全管理当前租户文件。",
  "system.files.detail.no_usages": "该文件当前没有业务引用。",
  "system.files.detail.scan_gate": "只有状态可用且扫描通过或明确跳过的文件才能选择或下载。",
  "system.files.detail.title": "文件详情",
  "system.files.detail.usages": "业务引用",
  "system.files.empty": "暂无匹配文件",
  "system.files.feedback.deleted": "文件已删除。",
  "system.files.feedback.downloaded": "已开始下载。",
  "system.files.filters.media": "媒体类型前缀",
  "system.files.filters.provider": "存储驱动",
  "system.files.filters.query": "搜索文件名",
  "system.files.filters.scan": "扫描状态",
  "system.files.filters.status": "文件状态",
  "system.files.filters.uploaded_from": "开始时间",
  "system.files.filters.uploaded_range": "上传时间范围",
  "system.files.filters.uploaded_to": "结束时间",
  "system.files.load_error": "文件加载失败。",
  "system.files.picker.description": "只能选择状态可用且扫描安全的文件。",
  "system.files.picker.preview.close": "关闭文件预览",
  "system.files.picker.preview.empty": "选择文件后可在此处预览",
  "system.files.picker.preview.error": "文件预览加载失败",
  "system.files.picker.preview.open": "展开文件预览",
  "system.files.picker.preview.title": "文件预览",
  "system.files.picker.preview.unsupported": "此文件类型暂不支持预览",
  "system.files.picker.selected": "已选择：{name}",
  "system.files.picker.title": "选择文件",
  "system.files.picker.type.all": "全部文件",
  "system.files.picker.type.image": "图片",
  "system.files.picker.type.label": "文件类型",
  "system.files.picker.type.other": "其他文件",
  "system.files.picker.type.video": "视频",
  "system.files.picker.view.grid": "网格视图",
  "system.files.picker.view.label": "切换文件视图",
  "system.files.picker.view.table": "表格视图",
  "system.files.picker.view.thumbnail": "缩略图视图",
  "system.files.picker.window.drag": "拖动选择文件对话框；按 Alt 加方向键可移动",
  "system.files.picker.window.maximize": "最大化对话框",
  "system.files.picker.window.resize": "调整对话框大小；方向键可调整，Shift 加速",
  "system.files.picker.window.restore": "还原对话框",
  "system.files.picker.window.split": "拖动调整文件列表和预览宽度",
  "system.files.provider.local": "本地存储",
  "system.files.provider.minio": "MinIO",
  "system.files.provider.s3": "S3 兼容存储",
  "system.files.scan.clean": "扫描通过",
  "system.files.scan.failed": "扫描失败",
  "system.files.scan.infected": "发现风险",
  "system.files.scan.pending": "等待扫描",
  "system.files.scan.skipped": "已明确跳过扫描",
  "system.files.status.pending": "待处理",
  "system.files.status.quarantined": "已隔离",
  "system.files.status.ready": "可用",
  "system.files.title": "文件存储",
  "system.files.upload.cancelled": "上传会话已取消，已上传分片已清理。",
  "system.files.upload.completed": "文件已上传并完成校验。",
  "system.files.upload.description": "文件按可续传的 5 MiB 分片上传，校验完成后才可使用。",
  "system.files.upload.error": "上传失败，可继续重试缺失分片。",
  "system.files.upload.invalid": "请选择不超过 100 MiB 的非空文件。",
  "system.files.upload.invalid_policy": "文件大小或类型不符合当前租户上传策略。",
  "system.files.upload.paused": "上传已暂停，继续时会保留已完成分片。",
  "system.files.upload.policy": "{provider} · 最大 {size}",
  "system.files.upload.policy_error": "上传策略不可用，请先完成云存储配置。",
  "system.files.upload.progress": "上传进度：{percent}%",
  "system.files.upload.title": "分片上传",
  "system.org.feedback.deleted": "删除成功",
  "system.org.feedback.moved": "移动成功",
  "system.org.feedback.saved": "保存成功",
  "system.org.filters.query": "按名称或编码搜索",
  "system.org.filters.status": "状态",
  "system.org.load_error": "组织数据加载失败。",
  "system.org.positions.actions.create": "新建岗位",
  "system.org.positions.actions.label": "操作",
  "system.org.positions.delete.impact": "当前关联成员数：{members}。有关联成员时服务端将拒绝删除。",
  "system.org.positions.delete.title": "删除岗位？",
  "system.org.positions.description": "维护租户岗位目录，并查看真实成员占用情况。",
  "system.org.positions.editor.create_title": "新建岗位",
  "system.org.positions.editor.edit_title": "编辑岗位",
  "system.org.positions.empty": "暂无岗位",
  "system.org.positions.fields.code": "岗位编码",
  "system.org.positions.fields.description": "岗位说明",
  "system.org.positions.fields.member_count": "成员数",
  "system.org.positions.fields.name": "岗位名称",
  "system.org.positions.fields.sort_order": "排序值",
  "system.org.positions.fields.status": "状态",
  "system.org.positions.filters.department": "按部门筛选",
  "system.org.unit_types.company": "公司",
  "system.org.unit_types.department": "部门",
  "system.org.unit_types.division": "事业部",
  "system.org.unit_types.group": "小组",
  "system.org.unit_types.team": "团队",
  "system.org.units.actions.create": "新建部门",
  "system.org.units.actions.move": "移动",
  "system.org.units.delete.impact": "直属下级：{children}；直属成员：{members}。存在占用时服务端将拒绝删除。",
  "system.org.units.delete.title": "删除部门？",
  "system.org.units.description": "维护租户组织树；移动表单完整支持键盘操作。",
  "system.org.units.editor.create_title": "新建部门",
  "system.org.units.editor.edit_title": "编辑部门",
  "system.org.units.empty": "暂无部门",
  "system.org.units.fields.child_count": "直属下级数",
  "system.org.units.fields.code": "部门编码",
  "system.org.units.fields.contact": "联系方式",
  "system.org.units.fields.direct_member_count": "直属成员数",
  "system.org.units.fields.email": "邮箱",
  "system.org.units.fields.name": "部门名称",
  "system.org.units.fields.parent_id": "上级部门",
  "system.org.units.fields.phone": "电话",
  "system.org.units.fields.sort_order": "排序值",
  "system.org.units.fields.status": "状态",
  "system.org.units.fields.unit_type": "组织类型",
  "system.org.units.move.description": "选择新的上级部门和排序值。不能移动到自身或任一下级。",
  "system.org.units.move.root": "顶级组织",
  "system.org.units.move.title": "移动部门",
  "system.org.units.tree_label": "组织树",
  "system.sessions.actions.revoke": "强制下线",
  "system.sessions.current_warning": "下方已标记此浏览器的当前会话；强制下线后您会立即退出登录。",
  "system.sessions.description": "使用服务端脱敏的账号、设备和 IP 提示检查租户会话，并强制下线风险会话。",
  "system.sessions.empty": "没有符合筛选条件的会话。",
  "system.sessions.fields.actions": "操作",
  "system.sessions.fields.application": "应用 / 平台",
  "system.sessions.fields.device": "设备提示",
  "system.sessions.fields.expires": "过期时间",
  "system.sessions.fields.ip": "IP 提示",
  "system.sessions.fields.last_seen": "最后活跃",
  "system.sessions.fields.status": "状态",
  "system.sessions.fields.user": "用户",
  "system.sessions.filters.audience": "应用",
  "system.sessions.filters.from": "活跃开始日期",
  "system.sessions.filters.ip": "匹配 IP",
  "system.sessions.filters.platform": "平台",
  "system.sessions.filters.search": "搜索用户名称或账号",
  "system.sessions.filters.status": "状态",
  "system.sessions.filters.to": "活跃结束日期",
  "system.sessions.revoke.current_impact": "这是您的当前会话；操作成功后您会立即退出登录。",
  "system.sessions.revoke.impact": "{user} 在 {device} 上的访问会立即失效，其刷新令牌族也会被撤销，并写入审计记录。",
  "system.sessions.revoke.success": "会话已强制下线并完成审计。",
  "system.sessions.revoke.title": "强制下线此会话？",
  "system.sessions.values.active": "活跃",
  "system.sessions.values.ak-admin": "管理端",
  "system.sessions.values.ak-api": "API",
  "system.sessions.values.ak-mobile": "移动端",
  "system.sessions.values.android": "Android",
  "system.sessions.values.current": "当前会话",
  "system.sessions.values.desktop": "桌面端",
  "system.sessions.values.expired": "已过期",
  "system.sessions.values.harmonyos": "HarmonyOS",
  "system.sessions.values.ios": "iOS",
  "system.sessions.values.revoked": "已撤销",
  "system.sessions.values.unknown": "未知",
  "system.sessions.values.web": "Web",
  "system.tenants.actions.create": "新建租户",
  "system.tenants.description": "管理当前租户、成员以及可用工作区。租户数据由服务端强制隔离。",
  "system.tenants.detail.back": "返回租户列表",
  "system.tenants.detail.members": "成员",
  "system.tenants.detail.overview": "概览",
  "system.tenants.editor.create_title": "新建租户",
  "system.tenants.empty": "暂无可见租户",
  "system.tenants.feedback.created": "租户 {name} 已创建，可从顶部切换工作区",
  "system.tenants.feedback.member_added": "成员已添加",
  "system.tenants.feedback.member_updated": "成员状态已更新",
  "system.tenants.feedback.saved": "租户信息已保存",
  "system.tenants.fields.code": "租户编码",
  "system.tenants.fields.created_at": "创建时间",
  "system.tenants.fields.members": "成员数",
  "system.tenants.fields.name": "租户名称",
  "system.tenants.fields.plan": "套餐",
  "system.tenants.fields.status": "状态",
  "system.tenants.filters.query": "搜索名称或编码",
  "system.tenants.filters.status": "按状态筛选",
  "system.tenants.load_error": "租户数据加载失败",
  "system.tenants.member_status.active": "正常",
  "system.tenants.member_status.left": "已退出",
  "system.tenants.member_status.suspended": "已停用",
  "system.tenants.members.actions": "操作",
  "system.tenants.members.activate": "启用",
  "system.tenants.members.add": "添加成员",
  "system.tenants.members.add_title": "添加现有用户",
  "system.tenants.members.confirm_active": "启用此成员？",
  "system.tenants.members.confirm_impact": "将更新 {name} 的租户成员状态；停用或移除会撤销其当前租户会话。",
  "system.tenants.members.confirm_left": "移除此成员？",
  "system.tenants.members.confirm_suspended": "停用此成员？",
  "system.tenants.members.display_name": "租户内显示名（可选）",
  "system.tenants.members.email": "用户邮箱",
  "system.tenants.members.empty": "暂无成员",
  "system.tenants.members.joined_at": "加入时间",
  "system.tenants.members.member": "成员",
  "system.tenants.members.remove": "移除",
  "system.tenants.members.roles": "角色",
  "system.tenants.members.status": "状态",
  "system.tenants.members.suspend": "停用",
  "system.tenants.status.active": "正常",
  "system.tenants.status.disabled": "已停用",
  "system.users.actions.create": "新建用户",
  "system.users.actions.disable": "停用",
  "system.users.actions.enable": "启用",
  "system.users.actions.export": "导出 CSV",
  "system.users.actions.import": "导入 CSV",
  "system.users.actions.label": "操作",
  "system.users.actions.more": "更多",
  "system.users.actions.reset_password": "重置密码",
  "system.users.bulk.disable_impact": "将停用 {count} 个租户成员并撤销其当前租户会话。",
  "system.users.bulk.disable_title": "停用 {count} 名用户？",
  "system.users.bulk.enable_impact": "将启用 {count} 个租户成员。",
  "system.users.bulk.enable_title": "启用 {count} 名用户？",
  "system.users.bulk.select_user": "选择 {name}",
  "system.users.bulk.selected": "已选择 {count} 项",
  "system.users.description": "管理当前租户的用户、角色、组织归属和登录会话。",
  "system.users.detail.access": "角色与组织",
  "system.users.detail.assignments": "部门与岗位",
  "system.users.detail.back": "返回用户列表",
  "system.users.detail.overview": "概览",
  "system.users.detail.roles": "角色",
  "system.users.detail.sessions": "登录会话",
  "system.users.disable.impact": "将停用 {name} 并撤销其 {sessions} 个当前租户活动会话。",
  "system.users.disable.title": "停用用户？",
  "system.users.editor.create_title": "新建用户",
  "system.users.editor.edit_title": "编辑用户",
  "system.users.empty": "暂无用户",
  "system.users.enable.impact": "将恢复该用户在当前租户的访问权限。",
  "system.users.enable.title": "启用用户？",
  "system.users.feedback.assignments_saved": "组织归属已保存",
  "system.users.feedback.bulk": "已更新 {count} 名用户",
  "system.users.feedback.created": "用户已创建，并将在首次登录时强制修改密码",
  "system.users.feedback.exported": "用户导出已开始下载",
  "system.users.feedback.imported": "导入完成：成功 {created}，失败 {failed}",
  "system.users.feedback.password_reset": "密码已重置，并撤销 {count} 个会话",
  "system.users.feedback.roles_saved": "角色已保存",
  "system.users.feedback.saved": "用户资料已保存",
  "system.users.feedback.session_revoked": "会话已撤销",
  "system.users.feedback.status": "用户状态已更新",
  "system.users.fields.created_at": "创建时间",
  "system.users.fields.department": "部门",
  "system.users.fields.display_name": "显示名称",
  "system.users.fields.email": "邮箱",
  "system.users.fields.last_login": "最近登录",
  "system.users.fields.locale": "语言",
  "system.users.fields.positions": "岗位",
  "system.users.fields.roles": "角色",
  "system.users.fields.status": "状态",
  "system.users.fields.temporary_password": "临时密码",
  "system.users.fields.time_zone": "时区",
  "system.users.fields.user": "用户",
  "system.users.filters.all_departments": "全部部门",
  "system.users.filters.department": "部门筛选",
  "system.users.filters.query": "搜索姓名、邮箱或用户名",
  "system.users.filters.sort": "排序",
  "system.users.filters.status": "状态筛选",
  "system.users.load_error": "用户数据加载失败。",
  "system.users.reset.impact": "为 {name} 设置临时密码；其全部 {sessions} 个活动会话将被撤销，并在下次登录时强制修改密码。",
  "system.users.reset.title": "重置用户密码？",
  "system.users.sessions.empty": "暂无登录会话",
  "system.users.sessions.ip": "IP 地址",
  "system.users.sessions.last_seen": "最近活动",
  "system.users.sessions.revoke": "撤销会话",
  "system.users.sessions.status.active": "活动",
  "system.users.sessions.status.expired": "已过期",
  "system.users.sessions.status.revoked": "已撤销",
  "system.users.sessions.user_agent": "客户端",
  "system.users.sort.created_asc": "创建时间升序",
  "system.users.sort.created_desc": "创建时间降序",
  "system.users.sort.last_login_desc": "最近登录优先",
  "system.users.sort.name_asc": "名称升序",
  "system.users.status.active": "正常",
  "system.users.status.disabled": "已停用",
  "system.users.status.locked": "已锁定",
  "system.users.status.pending": "待激活",
  "webhooks.actions.create": "新建端点",
  "webhooks.actions.deliveries": "查看投递",
  "webhooks.actions.test": "发送测试",
  "webhooks.columns.actions": "操作",
  "webhooks.columns.delivery": "投递策略",
  "webhooks.columns.delivery_value": "最多 {attempts} 次 / {seconds} 秒超时",
  "webhooks.columns.events": "事件",
  "webhooks.columns.name": "端点",
  "webhooks.columns.status": "状态",
  "webhooks.deliveries.columns.attempts": "尝试次数",
  "webhooks.deliveries.columns.created": "创建时间",
  "webhooks.deliveries.columns.event": "事件",
  "webhooks.deliveries.columns.status": "状态",
  "webhooks.deliveries.detail": "投递详情",
  "webhooks.deliveries.empty": "暂无投递记录",
  "webhooks.deliveries.fields.event_id": "事件 ID",
  "webhooks.deliveries.fields.payload": "事件载荷",
  "webhooks.deliveries.fields.response_status": "HTTP 状态",
  "webhooks.deliveries.fields.status": "状态",
  "webhooks.deliveries.fields.summary": "响应或错误摘要",
  "webhooks.deliveries.not_found": "Webhook 端点不存在或无权访问",
  "webhooks.deliveries.title": "“{name}”投递记录",
  "webhooks.delivery_status.cancelled": "已取消",
  "webhooks.delivery_status.failed": "失败",
  "webhooks.delivery_status.pending": "待投递",
  "webhooks.delivery_status.processing": "投递中",
  "webhooks.delivery_status.succeeded": "成功",
  "webhooks.description": "配置租户事件的签名 HTTPS 投递，并检查有界响应摘要。",
  "webhooks.editor.create": "新建 Webhook 端点",
  "webhooks.editor.edit": "编辑 Webhook 端点",
  "webhooks.editor.events": "事件代码",
  "webhooks.editor.events_help": "每行或逗号分隔，例如 order.created。",
  "webhooks.editor.max_attempts": "最大尝试次数",
  "webhooks.editor.name": "名称",
  "webhooks.editor.status": "状态",
  "webhooks.editor.timeout": "超时秒数",
  "webhooks.editor.url": "HTTPS 端点 URL",
  "webhooks.editor.url_help": "必须使用公开可路由的 HTTPS 主机；开发 Mock 可使用 hooks.example.test。",
  "webhooks.empty": "暂无匹配的 Webhook 端点",
  "webhooks.feedback.error": "Webhook 操作失败，请检查输入和权限",
  "webhooks.feedback.saved": "Webhook 端点已保存",
  "webhooks.feedback.test_failed": "测试投递失败；可在投递记录查看安全摘要",
  "webhooks.feedback.test_succeeded": "测试投递成功",
  "webhooks.feedback.validation": "请检查 URL、事件代码与投递限制",
  "webhooks.filters.event_type": "按事件代码筛选",
  "webhooks.filters.landmark": "Webhook 筛选",
  "webhooks.filters.query": "搜索名称或 URL",
  "webhooks.filters.status": "端点状态",
  "webhooks.safety.description": "禁止本机、私网、链路本地、多播地址和重定向；投递前重新解析 DNS，并用时间戳、事件 ID 与 HMAC-SHA256 签名。",
  "webhooks.safety.title": "强制 HTTPS 与服务端 SSRF 防护",
  "webhooks.secret.ack": "我已安全保存签名密钥",
  "webhooks.secret.close": "已保存并关闭",
  "webhooks.secret.title": "保存 Webhook 签名密钥",
  "webhooks.secret.value": "Webhook 签名密钥",
  "webhooks.secret.warning": "签名密钥只显示一次，服务端仅保存 AES-GCM 密文。请立即保存到接收方的安全配置。",
  "webhooks.status.active": "启用",
  "webhooks.status.disabled": "停用",
  "webhooks.test.confirm": "将向“{name}”发送事件 {event}。相同幂等键不会重复投递。",
  "webhooks.test.title": "发送签名测试事件",
  "webhooks.title": "Webhook",
  "ops.modules.ai.name": "AI 能力基座",
  "ops.modules.ai.description": "供应商、模型、授权调用与用量管理。",
  "ops.modules.support.name": "AI 客服",
  "ops.modules.support.description": "网站聊天、商品角色与人工接待。",
  "system.files.upload.processing": "正在校验并发布文件，请稍候。",
  "system.files.upload.invalid_content": "文件大小或实际类型不符合要求，请重新选择文件。",
  "system.files.upload.publish_failed": "文件发布失败，请联系管理员检查 Worker 与云存储配置。",
  "system.files.upload.scan_blocked": "文件未通过安全检查，无法公开。",
  "system.files.public_url": "公网地址",
  "system.files.public_url_not_ready": "公网地址尚未就绪，请完成云存储配置或等待文件发布。"
}
